<template>
  <div class="container-panel">
    <HeroFilter @routeHandler="getDataHandler" @searchHandler="getSearchData" />
    <DataGridTable
      :dataResult="itemResult"
      :dataDetails="itemFormData"
      :searchData="searchValue"
    />
    <AvailmentSOAModal
      :isModal="isCurrentActive"
      @updateModal="isCurrentActive = closeModal"
      @getDataResult="passData"
    />
  </div>
</template>
<script>
import HeroFilter from "@/components/common/HeroFilter.vue";
import DataGridTable from "@/components/partials/reports/availment-soa/DataGridTable.vue";
import AvailmentSOAModal from "@/components/partials/modals/AvailmentSOAModal.vue";
import { ref } from "vue";
export default {
  components: {
    HeroFilter,
    AvailmentSOAModal,
    DataGridTable,
  },
  setup() {
    const isCurrentActive = ref(false);
    const searchValue = ref();
    const itemResult = ref([]);
    const itemFormData = ref([]);
    const totalPages = ref();
    const currentPages = ref();
    const getDataHandler = (result) => {
      isCurrentActive.value = result;
    };
    const getSearchData = (search) => {
      searchValue.value = search;
    };

    const passData = (data, form) => {
      itemResult.value = data;
      itemFormData.value = form;
    };

    return {
      getDataHandler,
      getSearchData,
      passData,
      isCurrentActive,
      itemResult,
      itemFormData,
      searchValue,
      totalPages,
      currentPages,
    };
  },
};
</script>
